/* Phone only: mirror the product price INTO the Add to cart button, so
   the button reads "Add to cart · $44.80 $56.00" with the compare-at
   struck through. The standalone price block is hidden on phones (see
   tuti-global.css), leaving the button as the single place the price is
   stated.

   Mirrored rather than rendered in Liquid because the button markup is
   Horizon's (snippets/add-to-cart-button.liquid) and its label is a bare
   text node — and because <product-price> re-renders on every variant
   change and section morph. Reading from that element and re-reading it
   on mutation keeps the two in step without touching Horizon's snippet
   or duplicating its money formatting.

   The spans are always in the DOM; CSS hides them above 749px. Doing the
   viewport test in CSS rather than here means no work on resize and no
   flash if a cached page is opened at a different width. */
(function () {
  var SEP = '·'; /* middot divider between the label and the price */

  function findPrice(root) {
    /* The price block that belongs to THIS form. Scoped to the section so
       a quick-add modal or a recommendation card cannot be picked up. */
    return root.querySelector('product-price .price-item__group.price');
  }

  function findCompareAt(root) {
    return root.querySelector('product-price .compare-at-price');
  }

  /* The visually-hidden "Sale price"/"Regular price" labels live inside
     these nodes for screen readers; strip them so only the money is
     copied. */
  function moneyOf(el) {
    if (!el) return '';
    var clone = el.cloneNode(true);
    clone.querySelectorAll('.visually-hidden').forEach(function (n) {
      n.remove();
    });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  /* Horizon renders the label as a text node padded with newlines and
     indentation: "\n    \nAdd to cart\n    ". That trailing whitespace
     collapses to a real space, which lands BETWEEN the label and the
     divider dot — so the dot sat ~5px further from the label than from
     the price no matter what margins it was given. Trimming the node
     removes the phantom space and lets the dot's own equal margins hold.
     Only the label node is touched; the icon and burst spans are left
     alone. */
  function labelNodeOf(button) {
    for (var i = 0; i < button.childNodes.length; i++) {
      var node = button.childNodes[i];
      if (node.nodeType === 3 && node.textContent.trim()) return node;
    }
    return null;
  }

  function trimLabel(button) {
    var node = labelNodeOf(button);
    if (node) node.textContent = node.textContent.trim();
  }

  function sync(button, section) {
    var sale = moneyOf(findPrice(section));
    if (!sale) return;
    var compare = moneyOf(findCompareAt(section));

    trimLabel(button);

    var wrap = button.querySelector('.tuti-atc-price');
    if (!wrap) {
      wrap = document.createElement('span');
      wrap.className = 'tuti-atc-price';
      /* aria-hidden: the button already announces "Add to cart", and the
         price is announced by the price block itself. Without this the
         amount is read twice. */
      wrap.setAttribute('aria-hidden', 'true');
      /* Inserted directly AFTER the label, not appended at the end:
         Horizon's markup leaves a hidden burst span and an indentation
         text node between the two, and that text node collapses to a
         real space — which landed between the label and the divider dot
         and made its left gap ~5px wider than its right. */
      var label = labelNodeOf(button);
      if (label && label.nextSibling) button.insertBefore(wrap, label.nextSibling);
      else if (label) button.appendChild(wrap);
      else button.appendChild(wrap);
    }

    wrap.innerHTML = '';

    var sep = document.createElement('span');
    sep.className = 'tuti-atc-price__sep';
    sep.textContent = SEP;
    wrap.appendChild(sep);

    var now = document.createElement('span');
    now.className = 'tuti-atc-price__now';
    now.textContent = sale;
    wrap.appendChild(now);

    if (compare && compare !== sale) {
      var was = document.createElement('span');
      was.className = 'tuti-atc-price__was';
      was.textContent = compare;
      wrap.appendChild(was);
    }
  }

  function init() {
    var sections = document.querySelectorAll('.shopify-section');

    sections.forEach(function (section) {
      var button = section.querySelector('.add-to-cart-button');
      var price = section.querySelector('product-price');
      if (!button || !price) return;

      sync(button, section);

      /* <product-price> swaps its own subtree on variant change; watching
         the subtree catches that without guessing at event names. */
      var observer = new MutationObserver(function () {
        sync(button, section);
      });
      observer.observe(price, { childList: true, subtree: true, characterData: true });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
